import { useState, useRef, useEffect } from "react";

interface ProjectTabsProps {
  dropdownFilter: string;
  setDropdownFilter: (filter: string) => void;
  options?: string[];
  label?: string;
}

const PageContentFilterDropdown: React.FC<ProjectTabsProps> = ({
  dropdownFilter,
  setDropdownFilter,
  options = ["Latest", "Oldest"],
  label = "Sort by:",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      {/* Dropdown Button */}
      <div className="flex items-center">
        <span className="text-xs 2xl:text-sm text-gray-500 mr-2 whitespace-nowrap">
          {label}
        </span>
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="inline-flex space-x-3 w-full h-10 justify-center items-center rounded-md px-4 py-2 text-xs 2xl:text-sm font-medium text-gray-700 hover:bg-gray-50 border border-gray-200 focus:outline-none"
        >
          {dropdownFilter.replace("Select ", "")}
          <svg
            className="ml-5 h-[0.67rem] w-[0.67rem] 2xl:h-2.5 2xl:w-2.5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 10 6"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M0 0h10L5 6z" />
          </svg>
        </button>
      </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <div
          className="absolute right-0 mt-2 min-w-32 whitespace-nowrap origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 z-10"
          role="menu"
          aria-orientation="vertical"
        >
          <div className="py-1">
            {options.map((item) => (
              <button
                key={item}
                onClick={() => {
                  setDropdownFilter(item);
                  setIsOpen(false);
                }}
                className={`block w-full px-4 py-2 text-xs 2xl:text-sm text-gray-700 hover:bg-gray-100 text-left ${
                  dropdownFilter === item ? "font-semibold" : ""
                }`}
              >
                {item}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PageContentFilterDropdown;
